<section class="admin-shell">
  <edu-admin-header />
  <div class="admin-shell-actions">
    <a-button class="admin-back-button" (click)="goBack()">
      <a-icon name="undo"></a-icon>
      {{ 'common.back' | translate }}
    </a-button>
  </div>
  <div class="admin-app">
    <div class="admin-content">
      <router-outlet />
    </div>
  </div>
</section>
